import React, { FC } from 'react';
import i18n from 'i18n-js';

import { WithColor } from '@styles/colors';
import { Text, View } from 'react-native';
import { AMOUNT_OF_TIME_EVENT_DELAYED_IN_MINS } from '@v2/pages/common/components/NCFileBatchEvents/constants';
import { font } from '@styles/fonts';
import { ContainerStyle } from '@interfaces/base';

interface DelayedEventsTextProps extends WithColor, ContainerStyle {}

const DelayedEventsText: FC<DelayedEventsTextProps> = ({ C, containerStyle }) => {
  return (
    <View style={containerStyle}>
      <Text style={[font['Caption 1'], { color: C('Label/Light/Tertiary') }]}>
        {' '}
        {i18n.t('Data may be up to {{timeAmount}} minutes delayed', { timeAmount: AMOUNT_OF_TIME_EVENT_DELAYED_IN_MINS })}
      </Text>
    </View>
  );
};

export { DelayedEventsText };
